export class ConfigUpload {
    extensoesSuportadas: string = "XLSX, XLS, CSV, JPG, PDF, DOC, DOCX, TXT";
    quantidadeMaxArquivos: number = 15;
    limiteTamanhoMB: number = 10;
}